<ng-container *ngIf="isOnAnalysis; else notOnAnalysis">
  <!-- Section for original languages -->
  <section *ngFor="let lang of document_languages | slice:0:1" tabindex="0" class="language_bar onAnalysis"
    [ariaLabel]="[(lang.type) + ' language - ' + (lang.language) + ' - Similarity ' + (percentageWithQuotes ? originalPercentage : originalPercentageWithoutQuotes) + '%']">
    <section class="original_section" *ngIf="lang.type == 'Original'">
      <header>
        <img [src]="['../../../../../../assets/report_v2/' + lang.type.toLowerCase() + '_lang.svg']" alt="">
        <h3>{{ 'app.original_language' | translate }}</h3>
      </header>
      <section (click)="toggleSources(lang, $event)">
        <button class="toggle_sources_btn" [ngClass]="{ 'sources_closed': lang.sourcesClosed }"><img
            src="../../../../../../assets/report_v2/up_down_arrow.svg" alt=""></button>
        <h4 class="paragraphStyle">{{ lang.language }}</h4>
        <div>
          <mat-progress-bar title="Progress Bar" id="similarity" mode="determinate"
            [value]="percentageWithQuotes ? originalPercentage : originalPercentageWithoutQuotes"></mat-progress-bar>
          <p class="paragraphStyle">{{ percentageWithQuotes ? originalPercentage : originalPercentageWithoutQuotes }}%
          </p>
        </div>
      </section>
      <section tabindex="0" class="sources"
        [ngClass]="{ 'closed': lang.sourcesClosed, 'excluded': selectedFilterText === 'Removed sources' }"
        aria-label="Matching Sources">
        <header class="sources_header">
          <h5>{{('new_entries.' + selectedFilterText.toLowerCase().split(' ').join('_').replace('%', '_percent')) |
            translate}}</h5>
          <button class="sources_menu_btn" role="button" tabindex="0" (click)="toggleMenu($event)" focusable
            aria-label="Button to filter sources. Press to filter">
            <img src="../../../../../../assets/report_v2/three-dots.svg" alt="Options of Matching Sources">
            <section *ngIf="isMenuOpen" class="sources_menu" cdkTrapFocus>
              <button class="sources_menu_opt" (click)="filterSources(0, null, $event)">{{
                'new_entries.show_matching_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(1, null, $event)">{{
                'new_entries.show_only_document_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(2, null, $event)">{{
                'new_entries.show_only_internet_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(3, null, $event)">{{
                'new_entries.show_removed_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(4, null, $event)">{{
                'new_entries.sources_below_1_percent' | translate }}</button>
            </section>
          </button>
        </header>
        <a class="disclaimer" href="https://support.inspera.com/hc/en-us/articles/15852859897501-Matching-sources"
          target="_blank">{{ 'new_entries.learn_more_about_matching_sources' | translate }}</a>
        <section class="sources_body">
          <ng-container
            *ngFor="let source of similarityAnalysis.originalSources.slice(0, lang.visibleSourcesCount); let i = index">
            <div *ngIf="!source.hide && (
              selectedFilterText === 'Removed sources' ? 
                source.isExcluded :
                (selectedFilterText === 'Sources below 1%' ? 
                  (source.percentage <= 1 && !source.isSentenceExcluded) : 
                  (source.percentage > 0 && !source.isSentenceExcluded)
                )
              )" class="source" [ngClass]="source.isExcluded ? 'excluded' : ''" tabindex="0" focusable
              [ariaLabel]="'Source number ' + source.no + ', similarity ' + (source.percentage == 0 ? 0 : source.percentage?.toFixed(2)) + '%. Press the X button to remove the source.'">
              <button tabindex="0" [ariaLabel]="'Source Number' + source.no" class="source_no"
                (click)="selectSourceToHighlight(source.no)"
                [ngClass]="{'selectedSource' : selectedSources.includes(source.no)}">{{ source.no }}</button>
              <span tabindex="-1" class="source_percentage">{{ source.percentage == 0 ? 0 :
                source.percentage?.toFixed(2) }}%
                <button *ngIf="source.percentage == 0" class="tooltip_btn" matTooltipClass="new_report_tooltip reverse"
                  matTooltip="All sentences of this source are excluded">
                  <img src="../../../../../assets/report_v2/info-empty.svg" alt="More info about excluded source" />
                </button>
              </span>

              <a tabindex="0" *ngIf="source.sourceUrl" class="source_url" [href]="source.sourceUrl" target="_blank">{{
                source.sourceUrl }}</a>
              <p tabindex="0" *ngIf="!source.sourceUrl" class="source_url"
                (click)="startDocumentPreview(source.sourceId,lang,source.sourceIndex)">{{
                'new_entries.private_document_source' |
                translate }}</p>
              <button *ngIf="canEdit" class="remove_source" [ngClass]="{'rotate':source.isExcluded}"
                (click)="sourceAction(source.no,source.sourceUrl,source.sourceId, !source.isExcluded, source.percentage, source.languageCode || 'original')"><img
                  src="../../../../../../assets/report_v2/delete-circled.svg" alt=""></button>
            </div>
          </ng-container>
          <span *ngIf="similarityAnalysis.originalSources.length == 0">{{ 'new_entries.no_sources_for_filter' |
            translate }}</span>
          <button aria-label="View More Sources" class="more_sources" (click)="loadMoreSources(lang)">{{
            'new_entries.view_more_sources' | translate }}</button>
        </section>
      </section>
    </section>
  </section>

  <!-- Section for translated languages -->
  <section class="translated_section" *ngIf="isDocumentTranslated">
    <header>
      <img [src]="['../../../../../../assets/report_v2/translated_lang.svg']" alt="">
      <div class="border-right">
        <h3>{{ 'general.translated_language' | translate }}</h3>
        <p>{{ 'new_entries.overall_similarity_across_languages' | translate }}</p>
      </div>
      <p class="translations_total_percentage">{{ percentageWithQuotes ? overallTransltedPercentage :
        overallTransltedPercentageWithoutQuotes }}%</p>
    </header>
    <section *ngFor="let lang of document_languages | slice:1" class="language_section">

      <section (click)="toggleSources(lang, $event)">
        <button class="toggle_sources_btn" [ngClass]="{ 'sources_closed': lang.sourcesClosed }"><img
            src="../../../../../../assets/report_v2/up_down_arrow.svg" alt=""></button>
        <h4 class="paragraphStyle">{{ lang.language }}</h4>
        <div>
          <mat-progress-bar title="Progress Bar" id="similarity" mode="determinate"
            [value]="percentageWithQuotes ? lang.percentage : lang.percentageWithoutQuotes"></mat-progress-bar>
          <p class="paragraphStyle">{{ percentageWithQuotes ? (lang.percentage == 0 ? '0' : lang.percentage?.toFixed(2))
            : (lang.percentageWithoutQuotes == 0 ? '0' : lang.percentageWithoutQuotes?.toFixed(2)) }}%</p>
        </div>
      </section>
      <section tabindex="0" class="sources"
        [ngClass]="{ 'closed': lang.sourcesClosed, 'excluded': selectedFilterText === 'Removed sources' }"
        aria-label="Matching Sources">
        <header class="sources_header">
          <h5>{{('new_entries.' + selectedFilterText.toLowerCase().split(' ').join('_').replace('%', '_percent')) |
            translate}}</h5>
          <button class="sources_menu_btn" role="button" tabindex="0" (click)="toggleMenu($event)" focusable
            aria-label="Button to filter sources. Press to filter">
            <img src="../../../../../../assets/report_v2/three-dots.svg" alt="Options of Matching Sources">
            <section *ngIf="isMenuOpen" class="sources_menu" cdkTrapFocus>
              <button class="sources_menu_opt" (click)="filterSources(0, null, $event)">{{
                'new_entries.show_matching_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(1, null, $event)">{{
                'new_entries.show_only_document_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(2, null, $event)">{{
                'new_entries.show_only_internet_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(3, null, $event)">{{
                'new_entries.show_removed_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(4, null, $event)">{{
                'new_entries.sources_below_1_percent' | translate }}</button>
            </section>
          </button>
        </header>
        <a class="disclaimer" href="https://support.inspera.com/hc/en-us/articles/15852859897501-Matching-sources"
          target="_blank">{{ 'new_entries.learn_more_about_matching_sources' | translate }}</a>
        <section class="sources_body">
          <ng-container *ngFor="let langSources of similarityAnalysis.translatedSources; let i = index">
            <ng-container
              *ngIf="document_languages.slice(1).length == 1 && this.similarityAnalysis.submission.translatedPercentages == null; else otherTranslated">
              <div class="source" tabindex="0" focusable
                [ariaLabel]="'Source number ' + (i + 1) + ', similarity ' + langSources?.percentage?.toFixed(2) + '%. Press the X button to remove the source.'">
                <button tabindex="0" [ariaLabel]="'Source Number' + (i + 1)" class="source_no"
                  (click)="selectSourceToHighlight(langSources.no)"
                  [ngClass]="{'selectedSource' : selectedSources.includes(langSources.no)}">{{ i + 1 }}</button>
                <span tabindex="-1" class="source_percentage">{{ langSources.percentage == 0 ? 0 :
                  langSources.percentage?.toFixed(2) }}%</span>
                <a tabindex="0" *ngIf="langSources.sourceUrl" class="source_url" [href]="langSources.sourceUrl"
                  target="_blank">{{ langSources.sourceUrl }}</a>
                <p tabindex="0" *ngIf="!langSources.sourceUrl"
                  (click)="startDocumentPreview(langSources.sourceId,lang,langSources.sourceIndex)" class="source_url">
                  {{ 'new_entries.private_document_source' | translate }}</p>
                <button *ngIf="canEdit" [attr.aria-label]="langSources.isExcluded ? 'Include Source' : 'Remove Source'"
                  class="remove_source" [ngClass]="{'rotate':langSources.isExcluded}"
                  (click)="sourceAction(langSources.no,langSources.sourceUrl,langSources.sourceId, !langSources.isExcluded, langSources.percentage, langSources.languageCode || 'original')"><img
                    src="../../../../../../assets/report_v2/delete-circled.svg" alt=""></button>
              </div>
            </ng-container>
            <ng-template #otherTranslated>
              <div *ngIf="!langSources.hide && (
                selectedFilterText === 'Removed sources' ? 
                  langSources.isExcluded :
                  (selectedFilterText === 'Sources below 1%' ? 
                    (langSources?.percentage <= 1 && !langSources.isSentenceExcluded) : 
                    (langSources?.percentage > 0 && !langSources.isSentenceExcluded)
                  )
                )" class="source" tabindex="0" focusable
                [ariaLabel]="'Source number ' + (i + 1) + ', similarity ' + (langSources.percentage != null ? (langSources.percentage == 0 ? '0' : langSources.percentage?.toFixed(2)) : 'N/A') + '%. Press the X button to remove the source.'">
                <button tabindex="0" [ariaLabel]="'Source Number' + (i + 1)" class="source_no"
                  (click)="selectSourceToHighlight(langSources.no)"
                  [ngClass]="{'selectedSource' : selectedSources.includes(langSources.no)}">{{ i + 1 }}</button>
                <span tabindex="-1" class="source_percentage">{{ (langSources?.percentage == 0 ? 0 :
                  langSources?.percentage?.toFixed(2)) }}%
                  <button *ngIf="langSources.percentage == 0" class="tooltip_btn"
                    matTooltipClass="new_report_tooltip reverse" matTooltip="All sentences of this source are excluded">
                    <img src="../../../../../assets/report_v2/info-empty.svg" alt="More info about excluded source" />
                  </button>
                </span>

                <a tabindex="0" *ngIf="langSources.sourceUrl" class="source_url" [href]="langSources.sourceUrl"
                  target="_blank">{{ langSources.sourceUrl }}</a>
                <p tabindex="0" *ngIf="!langSources.sourceUrl"
                  (click)="startDocumentPreview(langSources.sourceId,lang,langSources.sourceIndex)" class="source_url">
                  {{ 'new_entries.private_document_source' | translate }}</p>
                <button *ngIf="canEdit" [attr.aria-label]="langSources.isExcluded ? 'Include Source' : 'Remove Source'"
                  class="remove_source" [ngClass]="{'rotate':langSources.isExcluded}"
                  (click)="sourceAction(langSources.no,langSources.sourceUrl,langSources.sourceId, !langSources.isExcluded, langSources.percentage, langSources.languageCode || 'original')"><img
                    src="../../../../../../assets/report_v2/delete-circled.svg" alt=""></button>
              </div>
              <span *ngIf="langSources?.length == 0">{{ 'new_entries.no_sources_for_filter' | translate }}</span>
            </ng-template>
          </ng-container>
          <span *ngIf="similarityAnalysis.translatedSources.length == 0">{{ 'new_entries.no_sources_for_filter' |
            translate }}</span>
          <button aria-label="View More Sources" class="more_sources" (click)="loadMoreSources(lang)"
            *ngIf="shouldShowLoadMoreButton(lang)">{{ 'new_entries.view_more_sources' | translate }}</button>
        </section>
      </section>
    </section>
  </section>

  <app-overview-disclaimer tabindex="0" [title]="'general.overview' | translate"
    [disclaimerText]="'new_entries.similarity_analysis_info' | translate"
    [disclaimerLink]="'https://support.inspera.com/hc/en-us/articles/25465296113437-Similarity-Analysis-In-Depth'"
    [linkText]="'new_entries.learn_more' | translate"></app-overview-disclaimer>
</ng-container>

<ng-template #notOnAnalysis>
  <section *ngFor="let lang of document_languages | slice:0:2; let i = index" tabindex="0" class="language_bar"
    [ariaLabel]="[(lang.type) + ' language - ' + (lang.type == 'Original' ? lang.language : transLangs) + ' - Similarity ' + (lang.type == 'Original' ? (percentageWithQuotes ? originalPercentage || 0 : originalPercentageWithoutQuotes || 0) : (percentageWithQuotes ? overallTransltedPercentage || 0 : overallTransltedPercentageWithoutQuotes || 0)) + '%']">
    <section class="similarity_overview_parent">
      <section class="similarity_overview">
        <div class="overview-head">
          <div *ngIf="originalityDisplay !== 'None'" class="overview-tag">
            <div *ngIf="originalityDisplay !== 'None'" class="overview-tag">

              <h3 *ngIf="originalityDisplay !== 'riskFactor'" class="tag" [ngClass]="{
                    'low': (lang.type === 'Original' ?
                      (percentageWithQuotes ? (lang.percentage >= 0 && lang.percentage <= mediumRiskThreshold) : (lang.percentageWithoutQuotes >= 0 && lang.percentageWithoutQuotes <= mediumRiskThreshold)) :
                      (percentageWithQuotes ? (similarityAnalysis.submission.translatedPercentage >= 0 && similarityAnalysis.submission.translatedPercentage <= mediumRiskThreshold) : (similarityAnalysis.submission.translatedPercentageWithoutQuotes >= 0 && similarityAnalysis.submission.translatedPercentageWithoutQuotes <= mediumRiskThreshold))),
                    'medium': (lang.type === 'Original' ?
                      (percentageWithQuotes ? (lang.percentage > mediumRiskThreshold && lang.percentage <= highRiskThreshold) : (lang.percentageWithoutQuotes > mediumRiskThreshold && lang.percentageWithoutQuotes <= highRiskThreshold)) :
                      (percentageWithQuotes ? (similarityAnalysis.submission.translatedPercentage > mediumRiskThreshold && similarityAnalysis.submission.translatedPercentage <= highRiskThreshold) : (similarityAnalysis.submission.translatedPercentageWithoutQuotes > mediumRiskThreshold && similarityAnalysis.submission.translatedPercentageWithoutQuotes <= highRiskThreshold))),
                    'high': (lang.type === 'Original' ?
                      (percentageWithQuotes ? (lang.percentage > highRiskThreshold && lang.percentage <= 100) : (lang.percentageWithoutQuotes > highRiskThreshold && lang.percentageWithoutQuotes <= 100)) :
                      (percentageWithQuotes ? (similarityAnalysis.submission.translatedPercentage > highRiskThreshold && similarityAnalysis.submission.translatedPercentage <= 100) : (similarityAnalysis.submission.translatedPercentageWithoutQuotes > 20 && similarityAnalysis.submission.translatedPercentageWithoutQuotes <= 100)))
                  }">
                <span class="round"></span>
                {{
                lang.type === 'Original'
                ? (percentageWithQuotes
                ? (lang.percentage == 0 ? '0' : lang.percentage?.toFixed(2))
                : (lang.percentageWithoutQuotes == 0 ? '0' : lang.percentageWithoutQuotes?.toFixed(2)))
                : (percentageWithQuotes
                ? (similarityAnalysis.submission.translatedPercentage == 0 ? '0' :
                similarityAnalysis.submission.translatedPercentage?.toFixed(2))
                : (similarityAnalysis.submission.translatedPercentageWithoutQuotes == 0 ? '0' :
                similarityAnalysis.submission.translatedPercentageWithoutQuotes?.toFixed(2)))
                }}%
              </h3>

              <h3 *ngIf="originalityDisplay === 'riskFactor'" class="tag" [ngClass]="{
                    'low': getPercentage(lang) < mediumRiskThreshold,
                    'medium': getPercentage(lang) >= mediumRiskThreshold && getPercentage(lang) < highRiskThreshold,
                    'high': getPercentage(lang) >= highRiskThreshold
                  }">
                <span class="round"></span>
                {{ getRiskLabel(lang) }}
              </h3>

            </div>

          </div>

          <img
            [src]="lang.type == 'Original' ? '../../../../../../assets/report_v2/original_lang_nav.svg' : '../../../../../../assets/report_v2/translated_lang_nav.svg'"
            alt="">
          <section class="overview">
            <div><span>{{ (lang.type == 'Original' ? 'app.original_language' : 'app.upload.translated_language') |
                translate }}:</span><span class="answ">{{ lang.type == 'Original' ? lang.language : transLangs.join(',
                ') }}</span></div>
            <div><span>{{ 'new_entries.matching_sources' | translate }}:</span><span class="answ">{{ lang.type ==
                'Original' ? filteredOriginalSources.length : filteredTranslatedSources.length }}</span></div>
          </section>
        </div>
        <section class="show_more">
          <button [attr.aria-expanded]="showTopSources === i ? true : false"
            [ngClass]="showTopSources === i ? 'rotateImg' : ''" (click)="toggleTopSources(i, lang)"><img
              src="../../../../../../assets/report_v2/arrow_down.svg" alt="">{{ (showTopSources === i ?
            'new_entries.hide_top_sources' : 'new_entries.show_top_sources') | translate }}</button>
        </section>
      </section>
      <section class="top_sources" [ngClass]="showTopSources === i ? 'open' : ''">
        <section class="top_sources_header">
          <h4 #heading tabindex="-1">{{ 'new_entries.top_sources' | translate }} ({{('new_entries.' +
            selectedFilterText.toLowerCase().split(' ').join('_').replace('%', '_percent')) | translate}})</h4>
          <button (click)="toggleSummaryMenu($event)" class="sources_menu_btn">
            <img src="../../../../../../assets/report_v2/three-dots.svg" alt="Filter options for Top sources">
            <section *ngIf="isSummaryMenuOpen" class="sources_menu" cdkTrapFocus>
              <button class="sources_menu_opt" (click)="filterSources(0, lang.type, $event)">{{
                'new_entries.show_matching_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(1, lang.type, $event)">{{
                'new_entries.show_only_document_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(2, lang.type, $event)">{{
                'new_entries.show_only_internet_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(3, lang.type, $event)">{{
                'new_entries.show_removed_sources' | translate }}</button>
              <button class="sources_menu_opt" (click)="filterSources(4, lang.type, $event)">{{
                'new_entries.sources_below_1_percent' | translate }}</button>
            </section>
          </button>
        </section>
        <section class="top_analyses">
          <ng-container *ngIf="lang.type == 'Original'">
            <ng-container *ngIf="filteredSources.length > 0; else noSourcesOriginal">
              <section class="content" *ngFor="let source of filteredSources"
                [ngClass]="{'excluded': source.isExcluded || selectedFilterText === 'Removed sources'}">
                <section class="head" tabindex="0"
                  [ariaLabel]="'This source is a ' + (source.type == 1 ? 'Submission Source' : (source.type == 2 ? 'Internet Source' : 'Premium Source')) + ' with ' + (source.percentage == 0 ? 0 : source.percentage?.toFixed(2)) + '% similarity.'">
                  <ng-container *ngIf="source.sourceUrl">
                    <img src="../../../../../../assets/report_v2/internet_source.svg" alt="">
                    <h5>{{ 'report.internet_sources' | translate }}</h5>
                  </ng-container>
                  <ng-container *ngIf="source.sourceId && !source.sourceUrl">
                    <img src="../../../../../../assets/report_v2/file_source.svg" alt="">
                    <h5>{{ 'general.submissions' | translate }}</h5>
                  </ng-container>
                  <ng-container *ngIf="source.type == 3">
                    <img src="../../../../../../assets/report_v2/premium_source.svg" alt="">
                    <h5>{{ 'new_entries.premium_content' | translate }}</h5>
                  </ng-container>
                  <button [ariaLabel]="source.isExcluded ? 'Include Source' : 'Exclude Source'" *ngIf="canEdit"
                    (click)="sourceAction(source.no,source.sourceUrl,source.sourceId, !source.isExcluded, source.percentage, source.languageCode || 'original')"><img
                      src="../../../../../../assets/report_v2/close-circle.svg"
                      [alt]="source.isExcluded ? 'Include Source' : 'Exclude Source'"></button>
                </section>
                <section class="body">
                  <p class="percentage"
                    [matTooltip]="source.percentage == 0 ? 'All sentences of this source are excluded' : ''">{{
                    source.percentage == 0 ? 0 : source.percentage?.toFixed(2) }}%</p>
                  <ng-container *ngIf="source.sourceUrl">
                    <a [href]="source.sourceUrl">{{ source.sourceUrl }}</a>
                  </ng-container>
                  <ng-container *ngIf="source.sourceId && !source.sourceUrl">
                    <p class="clickable" (click)="startDocumentPreview(source.sourceId,lang,source.sourceIndex)">{{
                      'new_entries.previous_submission' | translate }}</p>
                  </ng-container>
                  <ng-container *ngIf="source.type == 3">
                    <p>{{ 'new_entries.premium_content' | translate }}</p>
                  </ng-container>
                </section>
              </section>
            </ng-container>
            <ng-template #noSourcesOriginal>
              <span class="no_sources">{{ 'new_entries.no_sources_for_filter' | translate }}</span>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="lang.type == 'Translated'">
            <ng-container *ngIf="filteredSources.length > 0; else noSourcesTranslated">
              <section class="content" *ngFor="let source of filteredSources"
                [ngClass]="{'excluded': source.isExcluded || selectedFilterText === 'Removed sources'}">
                <section class="head">
                  <ng-container *ngIf="source.sourceUrl">
                    <img src="../../../../../../assets/report_v2/internet_source.svg" alt="">
                    <h5>{{ 'report.internet_sources' | translate }} (<span>{{ getLanguageName(source.languageCode)
                        }}</span>)</h5>
                  </ng-container>
                  <ng-container *ngIf="source.sourceId && !source.sourceUrl">
                    <img src="../../../../../../assets/report_v2/file_source.svg" alt="">
                    <h5>{{ 'general.submissions' | translate }} (<span>{{ getLanguageName(source.languageCode)
                        }}</span>)</h5>
                  </ng-container>
                  <ng-container *ngIf="source.type == 3">
                    <img src="../../../../../../assets/report_v2/premium_source.svg" alt="">
                    <h5>{{ 'new_entries.premium_content' | translate }} (<span>{{ getLanguageName(source.languageCode)
                        }}</span>)</h5>
                  </ng-container>
                  <button [ariaLabel]="source.isExcluded ? 'Include Source' : 'Exclude Source'" *ngIf="canEdit"
                    (click)="sourceAction(source.no,source.sourceUrl,source.sourceId, !source.isExcluded, source.percentage, source.languageCode)"><img
                      src="../../../../../../assets/report_v2/close-circle.svg"
                      [alt]="source.isExcluded ? 'Include Source' : 'Exclude Source'"></button>
                </section>
                <section class="body">
                  <p class="percentage"
                    [matTooltip]="source.percentage == 0 ? 'All sentences of this source are excluded' : ''">{{
                    source.percentage == 0 ? 0 : source.percentage?.toFixed(2) }}%</p>
                  <ng-container *ngIf="source.sourceId && !source.sourceUrl">
                    <p class="clickable" (click)="startDocumentPreview(source.sourceId,lang,source.sourceIndex)">{{
                      'new_entries.previous_submission' | translate }}</p>
                  </ng-container>
                  <ng-container *ngIf="source.type == 2">
                    <a [href]="source.sourceUrl">{{ source.sourceUrl }}</a>
                  </ng-container>
                  <ng-container *ngIf="source.type == 3">
                    <p>{{ 'new_entries.premium_content' | translate }}</p>
                  </ng-container>
                </section>
              </section>
            </ng-container>
            <ng-template #noSourcesTranslated>
              <span class="no_sources">{{ 'new_entries.no_sources_for_filter' | translate }}</span>
            </ng-template>
          </ng-container>
        </section>
      </section>
    </section>
  </section>
</ng-template>